import React from "react"
import { Infobox as InfoboxComponent } from "@outdoormap/gatsby-plugin-brand-sites"

import Styled from "../styled"
import { Anchor } from "../styled/anchor"
import { Heading6 } from "../styled/heading"
import { ReactComponent as SvgSheet } from "../../assets/images/icons/sheet.svg"

export default function Infobox({ data }) {
  return (
    <InfoboxComponent
      data={data}
      titles={{ files: `Djupkarta` }}
      Anchor={Anchor}
      Title={Heading6}
      Styled={Styled}
      DocumentSvg={SvgSheet}
    />
  )
}
